import React from "react";
import { QuoteIcon } from "lucide-react";
import { featuredTestimonial, testimonials } from "../data/testimonials";
export function Testimonials() {
  return <section aria-labelledby="temoignages-title" className="bg-paper py-20 md:py-28" data-id="element-177" data-mp="3ksqf566jze6h">
      <div className="mx-auto max-w-site px-5 md:px-8" data-id="element-178" data-mp="3fxkueaow05jz">
        <h2 id="temoignages-title" className="font-display text-4xl font-medium tracking-tight text-ink md:text-6xl" data-id="element-179" data-mp="3b1chl3y5wofz">
          Ils parlent de nous
        </h2>

        <figure className="mt-14 grid gap-8 lg:grid-cols-12" data-id="element-180" data-mp="31zw9j2utkyex">
          <QuoteIcon className="h-12 w-12 text-clay lg:col-span-1" strokeWidth={1.5} aria-hidden="true" data-id="element-181" data-mp="31ybg5gk8rlin" />
          <div className="lg:col-span-10" data-id="element-182" data-mp="2x11tg8o8lnyi">
            <blockquote className="font-display text-2xl font-normal leading-snug text-ink md:text-[2.25rem] md:leading-[1.3]" data-id="element-183" data-mp="2s1ymgiop57nw">
              {featuredTestimonial.quote}
            </blockquote>
            <figcaption className="mt-8 flex items-center gap-4" data-id="element-184" data-mp="qalj3y2dn7ty">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-forest font-display text-lg text-white" data-id="element-185" data-mp="q893vso07bkl">
                {featuredTestimonial.name.charAt(0)}
              </span>
              <span data-id="element-186" data-mp="m2ydyndqabto">
                <span className="block font-semibold text-ink" data-id="element-187" data-mp="780k1q2xleah">{featuredTestimonial.name}</span>
                <span className="block text-sm text-muted" data-id="element-188" data-mp="c6vexqe6atay">{featuredTestimonial.role}</span>
              </span>
            </figcaption>
          </div>
        </figure>

        <ul className="mt-20 grid gap-10 md:grid-cols-3 md:gap-12" data-id="element-189" data-mp="zx7rjekd5e7v">
          {testimonials.map(t => <li key={t.name} className="flex flex-col border-t border-line pt-7" data-id="element-190" data-mp="14xlpg3s937s6">
              <blockquote className="text-base leading-relaxed text-ink/85" data-id="element-191" data-mp="q63ckeuottd1">« {t.quote} »</blockquote>
              <p className="mt-auto pt-6 text-sm" data-id="element-192" data-mp="v3wkpdfjwxfy">
                <span className="font-semibold text-ink" data-id="element-193" data-mp="1ius69steywer">{t.name}</span>
                <span className="text-muted" data-id="element-194" data-mp="1ith766awyctz"> · {t.role}</span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}